"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface EquityTailoringQuestionsProps {
  onBack?: () => void;
}

const tailoringQuestions: TailoringQuestion[] = [
  {
    id: "EQT-1",
    question: "Are there any accounting estimates related to equity?",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "EQT-2",
    question: "Has there been any material movement in equity?",
    type: "radio",
    options: ["Yes", "No"],
  },
];

export default function EquityTailoringQuestions({ onBack }: EquityTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Equity"
      title="Equity - Tailoring Questions"
      description="Customize the audit program for Equity"
      questions={tailoringQuestions}
      onBack={onBack}
    />
  );
}
